import { EventNames } from '../../../../types/misc.types'
import { trackEvent } from '../../../../utils/appBridge'
import { PlansListEventIds, PlansLumpsumSheetEventIds, PlansSipSheetEventIds } from './plansEvents'

/**
 * Payload field map for fund hits (TrackEventPayload only):
 * - ScreenName → product surface + plan mode
 * - fundName / fundIsin → fund identity
 * - Fund open / tile open → buttonLabel = fund leg (buy / sell / start_sip / …)
 * - CTA with a visible label → buttonLabel = that label, scrollSection = fund leg
 */

export function trackPlansFundCardOpen({
  screenName,
  fundRole,
  fundName,
  fundIsin
}: {
  screenName: string
  fundRole?: string
  fundName: string
  fundIsin: string
}) {
  trackEvent({
    eventName: EventNames.UserClicked,
    payload: {
      ScreenName: screenName,
      eventId: PlansListEventIds.FundCard,
      buttonLabel: fundRole,
      fundName,
      fundIsin
    }
  })
}

export function trackPlansFundCardCta({
  screenName,
  fundRole,
  buttonLabel,
  fundName,
  fundIsin
}: {
  screenName: string
  fundRole?: string
  buttonLabel: string
  fundName: string
  fundIsin: string
}) {
  trackEvent({
    eventName: EventNames.ButtonTap,
    payload: {
      ScreenName: screenName,
      eventId: PlansListEventIds.FundCardCta,
      buttonLabel,
      scrollSection: fundRole,
      fundName,
      fundIsin
    }
  })
}

export function trackPlansLumpsumFundTileOpen({
  screenName,
  fundRole,
  fundName,
  fundIsin
}: {
  screenName: string
  fundRole?: string
  fundName: string
  fundIsin?: string
}) {
  trackEvent({
    eventName: EventNames.UserClicked,
    payload: {
      ScreenName: screenName,
      eventId: PlansLumpsumSheetEventIds.FundTileOpen,
      buttonLabel: fundRole,
      fundName,
      fundIsin
    }
  })
}

export function trackPlansLumpsumFundTilePrimaryCta({
  screenName,
  buttonLabel,
  fundName,
  fundIsin
}: {
  screenName: string
  buttonLabel: string
  fundName?: string
  fundIsin?: string
}) {
  trackEvent({
    eventName: EventNames.ButtonTap,
    payload: {
      ScreenName: screenName,
      eventId: PlansLumpsumSheetEventIds.PrimaryCta,
      buttonLabel,
      fundName,
      fundIsin
    }
  })
}

export function trackPlansSipFundTileOpen({
  screenName,
  fundRole,
  fundName,
  fundIsin
}: {
  screenName: string
  fundRole?: string
  fundName: string
  fundIsin?: string
}) {
  trackEvent({
    eventName: EventNames.UserClicked,
    payload: {
      ScreenName: screenName,
      eventId: PlansSipSheetEventIds.FundTileOpen,
      buttonLabel: fundRole,
      fundName,
      fundIsin
    }
  })
}

export function trackPlansSipFundTilePrimaryCta({
  screenName,
  buttonLabel,
  fundName,
  fundIsin
}: {
  screenName: string
  buttonLabel: string
  fundName?: string
  fundIsin?: string
}) {
  trackEvent({
    eventName: EventNames.ButtonTap,
    payload: {
      ScreenName: screenName,
      eventId: PlansSipSheetEventIds.PrimaryCta,
      buttonLabel,
      fundName,
      fundIsin
    }
  })
}
